import React from 'react';
import { browserHistory, withRouter } from 'react-router';
import Steps, { Step } from 'rc-steps';
import 'rc-steps/assets/index.css';

const SUMMARY_INDEX = 4;
const FINISHED_INDEX = 5;
const DEPOSIT_FUNDS_STEP = ['Deposit', 'Funds'];
const ONE_LINE_STEP = { position: 'relative !important', top: '6px !important' };

// Page each step goes back to, by step index. Steps without an entry are never clickable.
const STEP_PATHS = ['/account-type', '/personal-info', '/employment', '/financial'];

// Pages that own the way off themselves, so the whole bar is inert there: resubmit has its
// own "Review Information" button, and id-verify has to tear the Socure SDK down in its own
// back handler, which the bar would bypass.
const LOCKED_PATHS = ['/resubmit', '/id-verify'];

// Summary's Edit links carry ?redirectTo=/summary and submit returns the user there, so that
// round trip owns the way off the page just like LOCKED_PATHS do.
const hasRedirect = location => location.location.search.indexOf('redirectTo=') > -1;

const steps = [
  ['Account', 'Setup'],
  ['Personal', 'Information'],
  ['Employment', 'Information'],
  ['Financials &', 'Experience'],
  ['Settings &', 'Agreements'],
  ['Finished', ''],
];

const currentStep = (location) => {
  const path = location.location.pathname.substring(1);
  return parseInt(location.routes[0].childRoutes.find(r => r.path === path).step, 10);
};

const title = (stepIndex) => {
  return <div><span>{steps[stepIndex][0]}</span><span>{steps[stepIndex][1]}</span></div>;
};

// Only steps the user already got past are clickable, and only before the application is
// submitted. Going back relocks the steps ahead of the new position.
const isStepClickable = (index, current) => (
  current < FINISHED_INDEX
  && index < current
  && Boolean(STEP_PATHS[index])
);

const goToStep = (index) => {
  if (STEP_PATHS[index]) {
    browserHistory.push(STEP_PATHS[index]);
  }
};

// rc-steps makes a clickable step focusable but only wires up mouse clicks, so keyboard
// activation is handled here. The event bubbles up from the focusable step container.
const onStepKeyDown = index => (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    goToStep(index);
  }
};

const progressBarSteps = (isReturned, current, isLocked) => steps.map((step, index) => {
  const disabled = isLocked || !isStepClickable(index, current);
  const stepProps = {
    title: title(index),
    disabled,
    onKeyDown: disabled ? undefined : onStepKeyDown(index),
  };
  if (isReturned && index !== SUMMARY_INDEX) {
    return <Step key={index.toString()} {...stepProps} status="finish" />;
  }
  if (index !== FINISHED_INDEX) {
    return <Step key={index.toString()} {...stepProps} style={ONE_LINE_STEP} />;
  }
  return <Step key={index.toString()} {...stepProps} />;
});

const isUserInDepositFundsPage = (location) => {
  const locationIncludes = route => location.location.pathname.indexOf(route) > -1;
  if (locationIncludes('deposit-funds')) {
    steps.splice(5, 1, DEPOSIT_FUNDS_STEP);
  }
};

export const BaseProgressBar = (location) => {
  const isReturned = () => {
    const loc = location.location;
    return (loc.pathname.indexOf('summary') > -1 && loc.search.indexOf('returned') > -1);
  };
  isUserInDepositFundsPage(location);
  const current = currentStep(location);
  // A returned application edits through Summary's Edit links, already filtered to what
  // compliance unlocked. Every step here is locked or, like Account Setup, never unlockable,
  // so requireAuthentication bounces the user back to Summary.
  const returned = isReturned();
  const isLocked = returned
    || hasRedirect(location)
    || LOCKED_PATHS.some(p => location.location.pathname.indexOf(p) > -1);

  return (
    <section id="progressBar">
      <div className="fitv_element container-fluid">
        <div className="container notranslate progress-steps-container">
          <div className="row">
            <div className=" col col-md-12 col-lg-12">
              <Steps current={current} onChange={goToStep}>
                {progressBarSteps(returned, current, isLocked)}
              </Steps>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withRouter(BaseProgressBar);
